export const procurementTypeEnum = [1, 2]
export const purchaseTypeMap = {
  [procurementTypeEnum[0]]: '采购进货',
  [procurementTypeEnum[1]]: '采购退货'
}
export const purchaseStatusMap = {
  0: '已作废',
  1: '已收货',
  2: '已退货'
}

export const fundStatusMap = {
  4: { key: '已退款', countKey: 'asQuitTotalMoney' },
  3: { key: '未退款', countKey: 'noQuitTotalMoney' },
  2: { key: '已付款', countKey: 'asPayTotalMoney' },
  1: { key: '未付款', countKey: 'noPayTotalMoney' }
}
let allFundStatusKey = Object.keys(fundStatusMap)
export const procurementTypeFundStatus = {
  [procurementTypeEnum[0]]: allFundStatusKey
    .filter(item => item <= 2)
    .map(item => ({ value: item - 0, ...fundStatusMap[item] }))
    .reverse(), //为了展示效果倒序
  [procurementTypeEnum[1]]: allFundStatusKey
    .filter(item => item > 2)
    .map(item => ({ value: item - 0, ...fundStatusMap[item] }))
    .reverse()
}
